import Carousel from "../components/carousel";
import { ServiciosLegales, OtrosServicios } from "../data";
import { motion } from "framer-motion";
import { fadeIn } from "../utils/framer";
import { useState, useEffect } from "react";

const Servicios = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {isMobile ? (
        <div>
          <div className="mx-4 md:mx-60">
            <h1 className="text-3xl mb-10 mt-12 text-center md:text-left">
              Nuestros servicios ———
            </h1>
          </div>

          <div className="mb-12">
            <h2 className="text-2xl mb-6 text-center md:text-left">
              —— Servicios Legales
            </h2>
            <Carousel services={ServiciosLegales} />
          </div>

          <div className="mb-12">
            <h2 className="text-2xl mb-6 text-center md:text-left">
              —— Otros Servicios
            </h2>
            <Carousel services={OtrosServicios} />
          </div>
        </div>
      ) : (
        <motion.div
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false }}
        >
          <div className="mx-4 md:mx-60">
            <h1 className="text-3xl mb-10 mt-12 text-center md:text-left">
              Nuestros servicios ———
            </h1>
          </div>

          <div className="mb-12">
            <h2 className="text-2xl mb-6 text-center md:text-left">
              —— Servicios Legales
            </h2>
            <Carousel services={ServiciosLegales} />
          </div>


          <div className="mb-12">
            <h2 className="text-2xl mb-6 text-center md:text-left">
              —— Otros Servicios
            </h2>
            <Carousel services={OtrosServicios} />
          </div>
        </motion.div>
      )}
    </>
  );
};

export default Servicios;
